import { IHighlight } from "@financial-advisory/ui/components/pdf-viewer";

/**
 * Re-export all shared decision process types.
 * Financial-advisory specific types are defined below.
 */
export * from "@unlikelyai-magic/shared/data-access/api";

// ============================================================================
// Financial-advisory specific types
// ============================================================================

export interface FileHighlights {
  filename: string;
  highlights: IHighlight[];
}

export interface GetHighlightsResponse {
  data: IHighlight[];
}

/**
 * Rect type for PDF highlight positioning.
 * Similar to BoundingRect but kept separate for compatibility with pdf-viewer.
 */
export interface Rect {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  width: number;
  height: number;
}
